import { api } from '@/lib/api';
import type { StaffChatMessage, StaffChatSummary } from './types';

export const staffChatKeys = {
  all: ['staff-chat'] as const,
  summary: (userId: string) => ['staff-chat', userId, 'summary'] as const,
  messages: (userId: string, providerId: string) =>
    ['staff-chat', userId, 'messages', providerId] as const,
};

export const staffChatApi = {
  summary: () =>
    api.get<StaffChatSummary>('/staff-chat/summary').then((r) => r.data),
  messages: (providerId: string) =>
    api
      .get<StaffChatMessage[]>(`/staff-chat/threads/${providerId}/messages`)
      .then((r) => r.data),
  send: (providerId: string, body: string) =>
    api
      .post<StaffChatMessage>(`/staff-chat/threads/${providerId}/messages`, {
        body,
      })
      .then((r) => r.data),
  read: (providerId: string) =>
    api.post(`/staff-chat/threads/${providerId}/read`, {}).then((r) => r.data),
};
